import api from 'apis'
/**
 *  TIO首页持久化信息
 * */
let date = new Date()
function addZero (val) {
  return val >= 10 ? val : '0' + val
}
export default {
  namespaced: true,
  state: {
      keyword: [], // 搜索记录
      // 最近联系人
      contacts: [],
	  currentUserInfo: {} // 当前用户信息
  },
  getters: {
    contactsList: state => {
        return state.contacts.map(item => {
          let date1 = new Date(item.timer.substr(0, 10));
          let date2 = new Date(date.getFullYear() + '/' + addZero(date.getMonth() + 1) + '/' + addZero(date.getDate()));
          let dateDiff = date2.getTime() - date1.getTime()
          let diff = Math.floor(dateDiff / (24 * 3600 * 1000))
          if (diff === 0) {
            item.timer = addZero(date.getHours()) + ':' + addZero(date.getMinutes())
          } else if (diff === 1) {
            item.timer = '昨天'
          } else {
            item.timer = item.timer.substr(0, 10)
          }
          item.timer = '' // todo 先隐藏时间 对接app端通话记录
          return item
        })
    }
},
  actions: {
      /**
       * @description 设置最近联系人
       * @param {Object} state vuex state
       * @param {Object} dispatch vuex dispatch
       * @param {*} info info
       */
      setContacts ({ state, dispatch }, info) {
          return new Promise(async resolve => {
              // store 赋值
              state.contacts = info;

              // 持久化
              await dispatch('db/set', {
                  dbName: 'database',
                  path: 'contacts',
                  value: info
              }, { root: true });
              // end
              resolve();
          })
      },
      /**
       * @description 从数据库取最近联系人
       * @param {Object} state vuex state
       * @param {Object} dispatch vuex dispatch
       */
      loadContacts ({ state, dispatch }) {
          return new Promise(async resolve => {
              // store 赋值
              state.contacts = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'contacts',
                  defaultValue: {}
              }, { root: true });
              // end
              resolve();
          })
      },
      reLoadContacts ({ state, dispatch }) {
        return new Promise(async resolve => {
            // store 赋值
            state.contacts = JSON.parse(localStorage.getItem('TIO')).database.contacts
            // end
            resolve();
        })
    },
    /**
       * @description 设置搜索记录
       * @param {Object} state vuex state
       * @param {Object} dispatch vuex dispatch
       * @param {*} info info
       */
      setKeyword ({ state, dispatch }, info) {
        return new Promise(async resolve => {
            // store 赋值
            state.keyword = info;
            // 持久化
            await dispatch('db/set', {
                dbName: 'database',
                path: 'mailKeyword',
                value: info
            }, { root: true });
            // end
            resolve();
        })
    },

    /**
     * @description 从数据库取搜索记录
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     */
    loadKeyword ({ state, dispatch }) {
        return new Promise(async resolve => {
            // store 赋值
            state.keyword = await dispatch('db/get', {
                dbName: 'database',
                path: 'mailKeyword',
                defaultValue: []
            }, { root: true });
            // end
            resolve();
        })
    },
    reLoadKeyword ({ state, dispatch }) {
      return new Promise(async resolve => {
          // store 赋值
          state.keyword = JSON.parse(localStorage.getItem('TIO')).database.mailKeyword
          // end
          resolve();
      })
  },
    getStaffCode({ state, dispatch }) {
        return new Promise(async resolve => {
	        const res = await api.getStaffCode();
	        state.currentUserInfo = res.data;
	        resolve(res.data);
        })
    }
  }
}
